import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onRemoveContent", "contents", "onOpenAssetPicker", "onOpenPlaylistPicker"];
import React from 'react';
import { useTranslation } from 'react-i18next';
import useUniqueId from 'hooks/useUniqueId';
import FormField from 'components/FormField';
import { Menu, MenuButton, MenuItem, MenuList } from 'components/Menu';
import Stack from 'components/Stack';
import Text from 'components/Text';
import Flex from 'components/Flex';
import ContentList from './ContentList';
function ContentField(_ref) {
  var onRemoveContent = _ref.onRemoveContent,
    _ref$contents = _ref.contents,
    contents = _ref$contents === void 0 ? [] : _ref$contents,
    onOpenAssetPicker = _ref.onOpenAssetPicker,
    onOpenPlaylistPicker = _ref.onOpenPlaylistPicker,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var menuId = useUniqueId();
  var hasNoContent = contents.length === 0;
  return /*#__PURE__*/React.createElement(FormField, _extends({
    required: true,
    as: "fieldset",
    label: t("".concat(t('form_content_plural'), " *")),
    horizontalLabelOffset: "xxs"
  }, otherProps), /*#__PURE__*/React.createElement(Stack, {
    spacing: "xs"
  }, hasNoContent ? /*#__PURE__*/React.createElement(Flex, {
    border: "dashed",
    borderRadius: "small",
    p: "s",
    minHeight: 61
  }, /*#__PURE__*/React.createElement(Text, {
    dimmed: true
  }, t('error_no_content_selected'))) : /*#__PURE__*/React.createElement(ContentList, {
    contents: contents,
    onRemoveContent: onRemoveContent
  }), /*#__PURE__*/React.createElement(Menu, {
    id: menuId
  }, /*#__PURE__*/React.createElement(MenuButton, {
    iconRight: "chevron",
    icon: "plus",
    "aria-label": t('actions_add_content'),
    size: "medium"
  }, t('actions_add_content')), /*#__PURE__*/React.createElement(MenuList, null, /*#__PURE__*/React.createElement(MenuItem, {
    onClick: onOpenAssetPicker
  }, t('actions_add_asset')), /*#__PURE__*/React.createElement(MenuItem, {
    onClick: onOpenPlaylistPicker
  }, t('actions_add_playlist'))))));
}
export default ContentField;